import * as setup from '@/setup';
import Button from '@/objects/button';
import runtime from '@/runtime';
import * as audio from '@/utils/audio';
import * as pwa from '@/utils/pwa';
import * as shareUtils from '@/utils/share';
import axios from 'axios';
import * as config from '@/config-APP_TARGET';

/**
 * Chiave localStorage per tracciare le sfide concluse già viste
 */
var SEEN_COMPLETED_CHALLENGES_KEY = 'seen_completed_challenges';

export default class MainMenu extends Phaser.Scene {
	constructor() {
		super({key: 'MainMenu'});
		this.challengeBadge = null;
		this.challengeBadgeText = null;
	}

	create() {
		// Disabilita temporaneamente gli input per evitare click propagati
		this.input.enabled = false;

		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;
		const centerY = height / 2;

		// Background
		this.add
			.image(centerX, height / 2, 'background')
			.setOrigin(0.5, 0.5);

		// Logo
		this.add
			.image(centerX, 60, 'logo')
			.setOrigin(0.5, 0.5)
			.setScale(0.45);

		// Titolo
		this.add.text(
			centerX,
			140,
			'MENU PRINCIPALE',
			{
				fontSize: 48,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5);

		// Lista bottoni del menu
		const buttons = [
			{ label: 'Giochi', scene: 'GameSelection', icon: 'green-button' },
			{ label: 'Sfide', scene: 'Challenge', icon: 'blue-button' },
			{ label: 'Classifiche', scene: 'Rankings', icon: 'orange-button' },
			{ label: 'Profilo', scene: 'Profile', icon: 'orange-button' },
			{ label: 'Impostazioni', scene: 'Settings', icon: 'gray-button' },
			{ label: 'Condividi', action: 'share', icon: 'blue-button' },
			{ label: 'Installa', action: 'install', icon: 'green-button' }
		];

		const buttonSpacing = 100;
		const startY = centerY - (buttons.length * buttonSpacing) / 2 + 60;

		var scene = this;

		buttons.forEach((buttonConfig, index) => {
			const y = startY + (index * buttonSpacing);

			const menuButton = new Button(
				this,
				centerX,
				y,
				buttonConfig.icon,
				1.3,
				buttonConfig.label,
				false
			);

			// Se questo e il bottone Sfide, crea il badge
			if (buttonConfig.label === 'Sfide') {
				scene.createChallengeBadge(centerX + 80, y - 30);
			}

			menuButton.on('pointerup', () => {
				if (buttonConfig.action === 'share') {
					// Azione condivisione link generale del gioco
					audio.playSound(this, 'button-click');

					var self = this;
					var shareUrl = window.location.origin;

					shareUtils.shareOrCopy(
						shareUrl,
						'Gioca a Tanaca!',
						'Sfida i tuoi amici a colpi di libri, film e canzoni di Sanremo!'
					).then(function(result) {
						if (result.success) {
							var message = result.method === 'share'
								? 'Condivisione avviata!'
								: 'Link copiato!';
							self.showShareSuccess(message, result.method);
						} else {
							self.showMessage('Condivisione non riuscita');
						}
					});
				} else if (buttonConfig.action === 'install') {
					// Azione speciale per installazione PWA
					audio.playSound(this, 'button-click');

					// Verifica se l'installazione è disponibile
					if (!pwa.canInstall()) {
						// Mostra messaggio se l'installazione non è possibile
						if (pwa.isInstalled()) {
							this.showMessage('App già installata!');
						} else {
							this.showMessage('Installazione non disponibile\nsu questo browser');
						}
						return;
					}

					// iOS Safari: mostra istruzioni manuali
					if (pwa.needsIOSInstructions()) {
						this.showIOSInstructions();
						return;
					}

					// Android/Chrome: mostra prompt nativo
					pwa.showInstallPrompt().then((accepted) => {
						if (accepted) {
							menuButton.setVisible(false);
						}
					});
				} else if (buttonConfig.scene) {
					// Se c'è un gioco in corso e stiamo andando a Challenge,
					// usa launch invece di start per mantenere il menu in background
					const isGameInProgress = runtime.gameInProgress === true;

					if (isGameInProgress && buttonConfig.scene === 'Challenge') {
						// Metti in pausa questo menu e lancia Challenge sopra
						this.scene.pause();
						this.scene.launch(buttonConfig.scene);
						this.scene.bringToTop(buttonConfig.scene);
					} else {
						this.scene.start(buttonConfig.scene);
					}
				} else {
					// Mostra messaggio che la funzionalità è in sviluppo
					this.showComingSoon(buttonConfig.label);
				}
			});
		});

		// Bottone indietro in basso
		const backButton = new Button(
			this,
			centerX,
			height - 80,
			'red-button',
			1.3,
			'Indietro',
			false
		);

		backButton.on('pointerup', () => {
			audio.playSound(this, 'button-click');
			// Verifica se c'è un gioco in corso usando il flag globale
			const isGameInProgress = runtime.gameInProgress === true;

			console.log('MainMenu back button - gameInProgress:', isGameInProgress);

			if (isGameInProgress) {
				// Riprendi la scena Game e chiudi il menu
				this.scene.resume('Game');
				this.scene.stop();
			} else {
				// Altrimenti torna al Boot
				this.scene.start('Boot');
			}
		});



		// Riabilita gli input dopo un breve delay per evitare click propagati
		this.time.delayedCall(200, () => {
			this.input.enabled = true;
		});

		// Controlla le sfide pendenti ogni volta che si carica il menu
		this.checkPendingChallenges();
	}

	showComingSoon(feature) {
		// Mostra un messaggio temporaneo
		const message = this.add.text(
			this.sys.game.config.width / 2,
			this.sys.game.config.height / 2,
			`${feature}\nIn arrivo presto!`,
			{
				fontSize: 32,
				fontFamily: 'Luckiest Guy',
				fill: '#FFD700',
				align: 'center'
			}
		).setOrigin(0.5);

		// Rimuovi il messaggio dopo 2 secondi
		this.time.delayedCall(2000, () => {
			message.destroy();
		});
	}

	showMessage(text) {
		// Mostra un messaggio temporaneo al centro dello schermo con sfondo
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;

		const message = this.add.text(
			centerX,
			centerY,
			text,
			{
				fontSize: 28,
				fontFamily: 'Luckiest Guy',
				fill: '#CC0000',
				align: 'center'
			}
		).setOrigin(0.5);

		// Crea sfondo bianco con padding
		const padding = 30;
		const background = this.add.rectangle(
			centerX,
			centerY,
			message.width + padding * 2,
			message.height + padding * 2,
			0xFFFFFF,
			0.95
		).setOrigin(0.5);

		// Bordo arrotondato
		background.setStrokeStyle(3, 0xCC0000);

		// Porta il testo sopra lo sfondo
		message.setDepth(1);

		// Rimuovi tutto dopo 2 secondi
		this.time.delayedCall(2000, () => {
			message.destroy();
			background.destroy();
		});
	}

	/**
	 * Mostra messaggio di successo per la condivisione
	 * @param {string} text - Testo da mostrare
	 * @param {string} method - Metodo usato ('share' o 'copy')
	 */
	showShareSuccess(text, method) {
		var centerX = this.sys.game.config.width / 2;
		var centerY = this.sys.game.config.height / 2;

		// Colore in base al metodo
		var color = method === 'share' ? '#4A90E2' : '#4CAF50';
		var borderColor = method === 'share' ? 0x4A90E2 : 0x4CAF50;

		var message = this.add.text(
			centerX,
			centerY,
			text,
			{
				fontSize: 28,
				fontFamily: 'Luckiest Guy',
				fill: color,
				align: 'center'
			}
		).setOrigin(0.5);

		// Crea sfondo bianco con padding
		var padding = 30;
		var background = this.add.rectangle(
			centerX,
			centerY,
			message.width + padding * 2,
			message.height + padding * 2,
			0xFFFFFF,
			0.95
		).setOrigin(0.5);

		// Bordo colorato
		background.setStrokeStyle(3, borderColor);

		// Porta il testo sopra lo sfondo
		message.setDepth(1);

		// Rimuovi tutto dopo 2 secondi
		var self = this;
		this.time.delayedCall(2000, function() {
			message.destroy();
			background.destroy();
		});
	}

	showIOSInstructions() {
		// Mostra istruzioni per installazione manuale su iOS Safari
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;
		const width = this.sys.game.config.width;

		// Container per tutti gli elementi del popup
		var popupElements = [];

		// Sfondo semi-trasparente che copre tutto
		var overlay = this.add.rectangle(
			centerX,
			centerY,
			width,
			this.sys.game.config.height,
			0x000000,
			0.7
		).setOrigin(0.5).setDepth(10).setInteractive();
		popupElements.push(overlay);

		// Box bianco centrale
		var boxWidth = width - 60;
		var boxHeight = 380;
		var box = this.add.rectangle(
			centerX,
			centerY,
			boxWidth,
			boxHeight,
			0xFFFFFF,
			1
		).setOrigin(0.5).setDepth(11);
		box.setStrokeStyle(3, 0x4A90D9);
		popupElements.push(box);

		// Titolo
		var title = this.add.text(
			centerX,
			centerY - 150,
			'INSTALLA TANACA',
			{
				fontSize: 32,
				fontFamily: 'Luckiest Guy',
				fill: '#4A90D9',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(12);
		popupElements.push(title);

		// Istruzioni
		var instructions = this.add.text(
			centerX,
			centerY - 20,
			'Per installare l\'app su iPhone/iPad:\n\n' +
			'1. Tocca l\'icona Condividi\n' +
			'   (il quadrato con la freccia in alto)\n\n' +
			'2. Scorri e tocca\n' +
			'   "Aggiungi a Home"\n\n' +
			'3. Tocca "Aggiungi"',
			{
				fontSize: 22,
				fontFamily: 'Arial',
				fill: '#333333',
				align: 'center',
				lineSpacing: 4
			}
		).setOrigin(0.5).setDepth(12);
		popupElements.push(instructions);

		// Bottone chiudi
		var closeButton = this.add.rectangle(
			centerX,
			centerY + 140,
			200,
			50,
			0x4A90D9,
			1
		).setOrigin(0.5).setDepth(12).setInteractive();
		popupElements.push(closeButton);

		var closeText = this.add.text(
			centerX,
			centerY + 140,
			'HO CAPITO',
			{
				fontSize: 24,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(13);
		popupElements.push(closeText);

		// Chiudi popup al click
		var self = this;
		closeButton.on('pointerup', function() {
			popupElements.forEach(function(el) {
				el.destroy();
			});
		});

		overlay.on('pointerup', function() {
			popupElements.forEach(function(el) {
				el.destroy();
			});
		});
	}

	/**
	 * Crea il badge per le sfide pendenti e concluse
	 * @param {number} x Posizione X del badge
	 * @param {number} y Posizione Y del badge
	 */
	createChallengeBadge(x, y) {
		var scene = this;

		// Cerchio rosso come sfondo del badge
		this.challengeBadge = this.add.circle(x, y, 18, 0xFF0000);
		this.challengeBadge.setDepth(10);

		// Testo del numero
		this.challengeBadgeText = this.add.text(
			x,
			y,
			'0',
			{
				fontSize: 20,
				fontFamily: 'Arial',
				fontStyle: 'bold',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5).setDepth(11);

		// Nascondi inizialmente
		this.challengeBadge.setVisible(false);
		this.challengeBadgeText.setVisible(false);

		// Aggiorna il badge con il valore corrente
		this.updateChallengeBadge();

		// Ascolta i cambiamenti nel registry per sfide pendenti
		this.registry.events.on('changedata-pending_challenges_count', function(parent, value) {
			scene.updateChallengeBadge();
		});

		// Ascolta i cambiamenti nel registry per sfide concluse
		this.registry.events.on('changedata-completed_challenges_count', function(parent, value) {
			scene.updateChallengeBadge();
		});
	}

	/**
	 * Aggiorna la visibilita e il valore del badge
	 * Mostra il totale delle sfide pendenti (da giocare) e concluse (nuovi risultati)
	 */
	updateChallengeBadge() {
		var pendingCount = this.registry.get('pending_challenges_count') || 0;
		var completedCount = this.registry.get('completed_challenges_count') || 0;
		var totalCount = pendingCount + completedCount;

		if (totalCount > 0) {
			// Mostra badge con il numero totale
			this.challengeBadge.setVisible(true);
			this.challengeBadgeText.setVisible(true);
			this.challengeBadgeText.setText(totalCount > 99 ? '99+' : String(totalCount));

			// Adatta la dimensione del cerchio se il numero e grande
			if (totalCount > 9) {
				this.challengeBadge.setRadius(22);
			} else {
				this.challengeBadge.setRadius(18);
			}
		} else {
			// Nascondi badge
			this.challengeBadge.setVisible(false);
			this.challengeBadgeText.setVisible(false);
		}
	}

	/**
	 * Ottiene gli ID delle sfide concluse già viste dal localStorage
	 * @returns {Array<number>}
	 */
	getSeenCompletedChallenges() {
		var stored = localStorage.getItem(SEEN_COMPLETED_CHALLENGES_KEY);
		if (stored) {
			try {
				return JSON.parse(stored);
			} catch (e) {
				return [];
			}
		}
		return [];
	}

	/**
	 * Controlla se ci sono sfide pendenti (da giocare) e sfide concluse (con risultato).
	 * Aggiorna il registry per far aggiornare il badge.
	 */
	checkPendingChallenges() {
		var scene = this;

		// Chiama entrambe le API in parallelo
		Promise.all([
			axios.get(config.apiUrl + '/api/invites'),
			axios.get(config.apiUrl + '/api/invites/sent')
		])
		.then(function(responses) {
			var receivedChallenges = responses[0].data || [];
			var sentChallenges = responses[1].data || [];

			// Sfide da giocare: ricevute con status WAITING (10) e senza challenged_round
			var pendingToPlay = receivedChallenges.filter(function(invite) {
				return invite.status === 10 && !invite.challenged_round;
			});

			// Sfide concluse: inviate con challenged_round completato (status 30 = CLOSED)
			var completedChallenges = sentChallenges.filter(function(invite) {
				return invite.challenged_round && invite.challenged_round.status === 30;
			});

			// Filtra le sfide concluse per trovare solo quelle NON ancora viste
			var seenIds = scene.getSeenCompletedChallenges();
			var newCompletedChallenges = completedChallenges.filter(function(invite) {
				return seenIds.indexOf(invite.id) === -1;
			});

			console.log('MainMenu - Sfide da giocare:', pendingToPlay.length);
			console.log('MainMenu - Sfide concluse (nuove):', newCompletedChallenges.length);

			// Salva nel registry (questo attiverà l'aggiornamento del badge)
			scene.registry.set('pending_challenges_count', pendingToPlay.length);
			scene.registry.set('pending_challenges_data', pendingToPlay);
			scene.registry.set('completed_challenges_count', newCompletedChallenges.length);
			scene.registry.set('completed_challenges_data', newCompletedChallenges);
		})
		.catch(function(error) {
			console.error('Errore controllo sfide:', error);
		});
	}
}
